import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { PaginationService } from 'src/app/PaginationService';
import { MatPaginatorModule } from '@angular/material/paginator';
import { messageService } from '../message.service';
import { PopupData } from '../support/excel-pdf/excel-pdf.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from '../editor/editor.component';

@Component({
  selector: 'app-forms-and-logs-reports',
  templateUrl: './forms-and-logs-reports.component.html',
  styleUrls: ['./forms-and-logs-reports.component.scss']
})
export class FormsAndLogsReportsComponent implements OnInit {
  isProcessing: boolean = false;
  showCharts: boolean = false;
  sortedTemplates: any[] = [];
  dateCustomClasses: DatepickerDateCustomClasses[];
  templateStatusList: any = [];
  templateNameList: any = [];
  formsTemplateNameList: any = [];
  formsSectionDataList: any = [];
  formsSectionDataStatusList: any = [];
  chartOptionsForTemplateStatus: any;
  chartOptionsForFormsTemplateName: any;
  chartOptionsForFormsStatus: any;
  chartOptionsForFormsSectionDataStatus: any;
  chartOptionsForFormsSectionData: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";
  dropDownFortemplateTypeList: any = [];
  templateDropDown: any = [];
  selectedTemplateType: any = null;
  templateTypeSearchText: string = '';
  tableReportTemplateStatusList: any = [];
  tableReportFormStatusList: any = [];
  tableReportFormSectionDataStatusList: any = [];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any = [];
  pagedItems1: any = [];
  pagedItems2: any = [];
  showReportFlagValue: any;
  whereValsForExcel: any;
  chartOptionsForTemplateStatusZoom: any;
  chartOptionsForFormsStatusZoom: any;
  chartOptionsForFormsSectionDataStatusZoom: any;

  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, public snackBar: MatSnackBar, public message: messageService,
    public elem: ElementRef, public paginationService: PaginationService, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute, public atPaginatorModule: MatPaginatorModule) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '90%',
    height: '600px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C'
  ];
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    console.log("prim", data);
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }
  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
    this.showReportFlagValue = "";
  }
  clickedChartVal: any;
  formsAndLogsChartDoubleClick(val: any) {
    this.createFormsAndLogsChartZoom(val);
    this.clickedChartVal = val;
    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);
    if (val == 2) {
      this.tableDataListForAll("formsStatus", "");
      this.clickedType = "formsStatus";
      this.clickedVal = "formsStatus";
      this.clickedStageStatusVal = "";
    } else if (val == 3) {
      this.tableDataListForAll("formsSectionDataStatus", "");
      this.clickedType = "formsSectionDataStatus";
      this.clickedVal = "formsSectionDataStatus";
      this.clickedStageStatusVal = "";
    }
  }

  createFormsAndLogsChartZoom(val: any) {
    if (val == 2) {
      this.chartOptionsForFormsStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Forms Status (${this.getTotalCountFormsStatusDataChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForFormsStatus(),
          click: this.handleFormsStatusClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
    if (val == 3) {
      this.chartOptionsForFormsSectionDataStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Forms Section Data Status (${this.getTotalCountFormsSectionDataChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForFormsSectionDataStatus(),
          click: this.handleFormsSectionDataStatusClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
  }
  createChart() {
    this.chartOptionsForTemplateStatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {

        text: `Template Status(${this.getTotalCountTemplateStatusDataChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForTemplateStatus(),
        click: this.handleTemplateStatusClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };

    this.chartOptionsForFormsStatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Forms Status (${this.getTotalCountFormsStatusDataChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFormsStatus(),
        click: this.handleFormsStatusClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };

    this.chartOptionsForFormsSectionDataStatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Forms Section Data Status (${this.getTotalCountFormsSectionDataChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{status}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForFormsSectionDataStatus(),
        click: this.handleFormsSectionDataStatusClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };
    this.showCharts = true;
  }
  getYAxisInterval() {
    const maxValue = Math.max(...this.formsTemplateNameList.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };

  getDataPointsForFormsSectionDataStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.formsSectionDataStatusList.map((ul: { count: any; status: any; }, index: any) => ({
      y: ul.count,
      indexLabel: `${ul.status}: ${ul.count}`,
      color: this.colorMethod(ul.status, index)
    }));
    return dataPoints;
  }
  handleFormsSectionDataStatusClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Form Section Data Status Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("formsSectionDataStatus", this.formsSectionDataStatusList[e.dataPointIndex].status);
    this.clickedType = "Forms Section Data Status";
    this.clickedVal = this.formsSectionDataStatusList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountFormsSectionDataChart() {
    return this.formsSectionDataStatusList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  getDataPointsForFormsStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.formsTemplateNameList.map((ul: { count: any; status: any; }, index: any) => ({
      y: ul.count,
      indexLabel: `${ul.status}: ${ul.count}`,
      color: this.colorMethod(ul.status, index)
    }));
    return dataPoints;
  }
  handleFormsStatusClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Form Status Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("formsStatus", this.formsTemplateNameList[e.dataPointIndex].status);
    this.clickedType = "Forms Status";
    this.clickedVal = this.formsTemplateNameList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }

  getTotalCountFormsStatusDataChart() {
    return this.formsTemplateNameList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  getDataPointsForTemplateName() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.templateNameList.map((ul: { count: any; templateName: any; }, index: any) => ({
      y: ul.count,
      indexLabel: `${ul.templateName}: ${ul.count}`,
      color: this.colorMethod(ul.templateName, index)
    }));
    return dataPoints;
  }
  handleTemplateNameClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Form Template Name Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("formsTemplateName", this.templateNameList[e.dataPointIndex].templateName);
    this.clickedType = "Forms Template Name";
    this.clickedVal = this.templateNameList[e.dataPointIndex].templateName;
    this.clickedStageStatusVal = "";
  }
  getTotalCountTemplateNameDataChart() {
    return this.formsTemplateNameList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  getDataPointsForTemplateStatus() {
    // Transform your data into CanvasJS dataPoints format
    const dataPoints = this.templateStatusList.map((ul: { count: any; status: any; }, index: any) => ({
      y: ul.count,
      indexLabel: `${ul.status}: ${ul.count}`,
      color: this.colorMethod(ul.status, index)
    }));
    return dataPoints;
  }

  handleTemplateStatusClick(e: any): void {
    // Handle pie chart click event here
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Template Status Report"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("templateStatus", this.templateStatusList[e.dataPointIndex].status);
    this.clickedType = "Template Status";
    this.clickedVal = this.templateStatusList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountTemplateStatusDataChart() {
    return this.templateStatusList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  tableDataList(type: any, valueOfWhere: any) {
    console.log("data", type)
    console.log("data", valueOfWhere)
    this.whereValsForExcel = "";
    let whereVals;
    if (type == "templateStatus") {
      this.showReportFlagValue = 1;
      whereVals = " STATUS='" + valueOfWhere + "'";
    } else if (type == "formsStatus") {
      whereVals = " AND STATUS='" + valueOfWhere + "'"
      this.showReportFlagValue = 2;
    } else if (type == "formsSectionDataStatus") {
      whereVals = " AND STATUS='" + valueOfWhere + "'"
      this.showReportFlagValue = 3;
    }
    this.whereValsForExcel = whereVals;
    let data = {

      templateId: this.selectedTemplateType == "All" ? null : this.selectedTemplateType,
      wherVal: whereVals
    }
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([
        this.appService.getTableTemplateStatus(data)]).subscribe(([templateStatusTableValues]) => {
          this.tableReportTemplateStatusList = templateStatusTableValues;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportTemplateStatusList.length;
          this.totalPages = Math.ceil(this.tableReportTemplateStatusList.length / this.itemsPerPage);
          this.setPage(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Template Name,Template Description,Status,ListOf Stages,Allow To Add New Form,Approval Requested On,Approved On,Approved By User,Approver Comments,Created On,Created By User,Updated On,Updated By User";
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getTableFormsStatus(data)]).subscribe(([formsStatusTableValues]) => {
          this.tableReportFormStatusList = formsStatusTableValues;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportFormStatusList.length;
          this.totalPages = Math.ceil(this.tableReportFormStatusList.length / this.itemsPerPage);
          this.setPage1(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Form Name,Form Description,Template Name,Template Description,Status,Header,Footer,Last Action On,Last Action Comments,Last Action From Status,Last Action By User,Locked On,Locked Comments,Completed On,Created On,Created By User,Updated On,Updated By User";
    } else if (this.showReportFlagValue == 3) {
      forkJoin([
        this.appService.getTableFormsSectionDataStatus(data)]).subscribe(([formsSectionDataStatusTableValues]) => {
          this.tableReportFormSectionDataStatusList = formsSectionDataStatusTableValues;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportFormSectionDataStatusList.length;
          this.totalPages = Math.ceil(this.tableReportFormSectionDataStatusList.length / this.itemsPerPage);
          this.setPage2(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Section Name,Form Name,Status,Is Verified,Verification Requested On,Verified By User,Verified On,Verifier Comments,Withdrawal Requested On,WithdrawN By User,Withdraw On,Withdrawer Comments,Locked By User,Created On,Created By User,Updated On,Updated By User";
    }


  }


  tableDataListForAll(type: any, valueOfWhere: any) {
    console.log("data", type)
    console.log("data", valueOfWhere)
    this.whereValsForExcel = "";
    let whereVals;
    if (type == "templateStatus") {
      this.showReportFlagValue = 1;
      whereVals = " ";
    } else if (type == "formsStatus") {
      whereVals = " "
      this.showReportFlagValue = 2;
    } else if (type == "formsSectionDataStatus") {
      whereVals = " "
      this.showReportFlagValue = 3;
    }
    this.whereValsForExcel = whereVals;
    let data = {

      templateId: this.selectedTemplateType == "All" ? null : this.selectedTemplateType,
      wherVal: whereVals
    }
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([
        this.appService.getTableTemplateStatus(data)]).subscribe(([templateStatusTableValues]) => {
          this.tableReportTemplateStatusList = templateStatusTableValues;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportTemplateStatusList.length;
          this.totalPages = Math.ceil(this.tableReportTemplateStatusList.length / this.itemsPerPage);
          this.setPage(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Template Name,Template Description,Status,ListOf Stages,Allow To Add New Form,Approval Requested On,Approved On,Approved By User,Approver Comments,Created On,Created By User,Updated On,Updated By User";
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getTableFormsStatus(data)]).subscribe(([formsStatusTableValues]) => {
          this.tableReportFormStatusList = formsStatusTableValues;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportFormStatusList.length;
          this.totalPages = Math.ceil(this.tableReportFormStatusList.length / this.itemsPerPage);
          this.setPage1(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Form Name,Form Description,Template Name,Template Description,Status,Header,Footer,Last Action On,Last Action Comments,Last Action From Status,Last Action By User,Locked On,Locked Comments,Completed On,Created On,Created By User,Updated On,Updated By User";
    } else if (this.showReportFlagValue == 3) {
      forkJoin([
        this.appService.getTableFormsSectionDataStatus(data)]).subscribe(([formsSectionDataStatusTableValues]) => {
          this.tableReportFormSectionDataStatusList = formsSectionDataStatusTableValues;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportFormSectionDataStatusList.length;
          this.totalPages = Math.ceil(this.tableReportFormSectionDataStatusList.length / this.itemsPerPage);
          this.setPage2(1, 0);
          this.isProcessing = false;
        });

      this.columnList = "Section Name,Form Name,Status,Is Verified,Verification Requested On,Verified By User,Verified On,Verifier Comments,Withdrawal Requested On,Withdrawn By User,Withdraw On,Withdrawer Comments,Locked By User,Created On,Created By User,Updated On,Updated By User";
    }
  }

  genReport() {
    console.log("this.selectedTemplateType=", this.selectedTemplateType)
    if (this.selectedTemplateType) {
      this.isProcessing = true;
      let data = {

        templateId: this.selectedTemplateType == "All" ? null : this.selectedTemplateType
      }
      const promises = [
        firstValueFrom(this.appService.getTemplateStatus(data)),
        firstValueFrom(this.appService.getTemplateName(data)),
        firstValueFrom(this.appService.getFormsStatus(data)),
        firstValueFrom(this.appService.getFormsSectionDataStatus(data)),
      ]; // Convert each observable to a promise
      // Use Promise.all to wait for all promises to resolve
      Promise.all(promises)
        .then(([templateStatusList, templateNameList, formsTemplateNameList, formsSectionDataStatusList]) => {
          this.templateStatusList = templateStatusList;
          this.templateNameList = templateNameList;
          this.formsTemplateNameList = formsTemplateNameList;
          this.formsSectionDataStatusList = formsSectionDataStatusList;
          this.createChart();
          this.isProcessing = false;
        },
          error => {
            console.error('Error in forkJoinObservable:', error);
            this.isProcessing = false;
          });
      this.tableDataListForAll("templateStatus", "");
      this.clickedType = "templateStatus";
      this.clickedVal = "templateStatus";
      this.clickedStageStatusVal = "";
    } else {
      this.fieldValidation("selectedTemplateId");
    }
  }
  moreFormsAndLogsReportDetails(value: any) {
    if (value == 'Default') {
      this.qmsservice.formsAndLogsReportFor = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/FormsAndLogsReports']);
    } else {
      this.qmsservice.formsAndLogsReportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate(['/dashboard/FormsAndLogsMoreReports']);
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const shouldBeRed = !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedTemplateType = item.displayExp;
      this.showCharts = false;

      this.handleDropDownValidation('selectedTemplateId', item)
    }
  }

  resetFunction() {
    this.selectedTemplateType = null;
    this.showCharts = false;
    this.tableReportTemplateStatusList = "";
  }

  fieldValidation(elementIds: string) {
    const element = document.getElementById(elementIds) as HTMLInputElement;
    element.style.color = 'red';
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportTemplateStatusList.length, page, this.perPage, targetpage);
    if (this.tableReportTemplateStatusList.length > 0) {
      this.pagedItems = this.tableReportTemplateStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportFormSectionDataStatusList.length, page, this.perPage, targetpage);
    if (this.tableReportFormSectionDataStatusList.length > 0) {
      this.pagedItems2 = this.tableReportFormSectionDataStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
      console.log("this.pagedItems2=", this.pagedItems2);
    }
  }

  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportFormStatusList.length, page, this.perPage, targetpage);
    if (this.tableReportFormStatusList.length > 0) {
      this.pagedItems1 = this.tableReportFormStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportTemplateStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportTemplateStatusList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }


  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportFormStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportFormStatusList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }


  applyFilter2(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportFormSectionDataStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportFormSectionDataStatusList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  //end excell & pdf

  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  data: any = {};
  data1: any = {};
  data2: any = {};
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  pdfSearchText: string = '';

  popupDataTitle: PopupData = {
    title: ''
  };
  openReportPopup(item: any) {
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;

    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + new Date();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }

  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = [];
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  whereValsForExcel1: any;
  onlyDateColumn: any;
  generateReport(value: any) {
    this.onlyDateColumn = "";
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      this.data = {};
      this.data1 = {};
      this.data2 = {};
      let tittle = "";
      let tname = "";
      let colList = "";
      let fieldList = "";
      this.whereValsForExcel1 = "";
      if (this.showReportFlagValue == 1) {
        tname = "ONEQMS_FORM_TEMPLATES_VW";
        colList = "TEMPLATE_NAME,TEMPLATE_DESCRIPTION,STATUS,LIST_OF_STAGES,ALLOW_TO_ADD_NEW_FORM,APPROVAL_REQUESTED_ON,APPROVED_ON,APPROVED_USER_BY_USER,APPROVER_COMMENTS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
        fieldList = this.columnList;
        tittle = "Template status";
        this.whereValsForExcel1 = this.whereValsForExcel;
        this.onlyDateColumn = "CREATED_ON,APPROVAL_REQUESTED_ON,APPROVED_ON,UPDATED_ON";
      } else if (this.showReportFlagValue == 2) {
        tname = "ONEQMS_FORMS_VW";
        colList = "FORM_NAME,FORM_DESCRIPTION,TEMPLATE_NAME,TEMPLATE_DESCRIPTION,STATUS,HEADER,FOOTER,LAST_ACTION_ON,LAST_ACTION_COMMENTS,LAST_ACTION_FROM_STATUS,LAST_ACTION_BY_USER,LOCKED_ON,LOCKED_COMMENTS,COMPLETED_ON,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
        fieldList = this.columnList;
        this.whereValsForExcel1 = " WHERE TEMPLATE_ID=" + this.selectedTemplateType + this.whereValsForExcel;
        tittle = "Form status";
        this.onlyDateColumn = "CREATED_ON,UPDATED_ON";
      } else if (this.showReportFlagValue == 3) {
        tname = "ONEQMS_FORM_SECTION_DATA_VW";
        colList = "SECTION_NAME,FORM_NAME,STATUS,IS_VERIFIED,VERIFICATION_REQUESTED_ON,VERIFIED_BY_USER,VERIFIED_ON,VERIFIER_COMMENTS,WITHDRAWAL_REQUESTED_ON,WITHDRAWN_BY_USER,WITHDRAWN_ON,WITHDRAWER_COMMENTS,LOCKED_BY_USER,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
        fieldList = this.columnList;
        this.whereValsForExcel1 = " WHERE TEMPLATE_ID=" + this.selectedTemplateType + this.whereValsForExcel
        tittle = "Form Section Data status";
        this.onlyDateColumn = "";
      }
      this.data = {

        "logoId": this.selectedReportLogoValue ?? 0,
        footer: this.selectedReportFooter,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "reportName": this.reportName ?? "FORMS_Report",
        "currentStatus": "NA",
        "groupName": tittle,
        groupId: null
      }
      this.data1 = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: "",
        codelistGroup: null,
        // manualEntryDataFields: "",
        manualEntryDataFields: this.onlyDateColumn,
        groupId: null,
        chartStatus: null,
        reModule: "fAndL"
      }
      this.data2 = {

        groupId: null,
        module: "DOCS",
        dateRangeAt: null,
        fromDate: null,
        toDate: null,
        intervals: null,
        taskType: null,
        wherVal: this.whereValsForExcel1
      }

      this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
      debugger;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: tittle, columns: [],
          "informationTab": {
            "Report Name": tittle,
            "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, tittle + ".xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: tittle, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, tittle + ".pdf");
      }
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();

          // Set the first object as default
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("FORMS")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  //end excell
  ngOnInit(): void {
    this.qmsservice.formsAndLogsReportFor = 'Default';
    this.isProcessing = true;

    const data = {

    };

    // Initialize template dropdown with "All" option
    this.templateDropDown = [
      { valueExp: "All", displayExp: "All" }
    ];

    // Fetch template dropdown data
    this.appService.getFormsTemplateDropdown(data).subscribe({
      next: (response: any) => {
        let parsedData: any[] = [];

        try {
          // Attempt to parse as JSON if it's a string
          if (typeof response === 'string') {
            // Try to extract JSON-like content
            const jsonString = response
              .replaceAll('}{', '}|{') // Fix missing commas between objects
              .split('|');

            parsedData = jsonString.map(obj => JSON.parse(obj.trim()));
          } else if (Array.isArray(response)) {
            parsedData = [...response];
          } else if (typeof response === 'object' && response !== null) {
            parsedData = [response];
          } else {
            console.warn('Unexpected response format:', response);
            parsedData = [];
          }

          // Filter out invalid items and deduplicate by templateId
          const templateMap = new Map<number, any>();

          for (const item of parsedData) {
            if (item?.templateId && item?.templateName) {
              const trimmedName = item.templateName.trim();
              if (trimmedName) {
                templateMap.set(item.templateId, { ...item, templateName: trimmedName });
              }
            }
          }

          // Convert map to array and sort alphabetically
          this.sortedTemplates = [...templateMap.values()].sort((a, b) =>
            a.templateName.localeCompare(b.templateName)
          );

          // Log cleaned & sorted list
          console.log('Sorted Templates:', this.sortedTemplates);

          // Populate dropdown
          for (const template of this.sortedTemplates) {
            this.templateDropDown.push({
              valueExp: template.templateId,
              displayExp: template.templateName
            });
          }

        } catch (error) {
          console.error('Error parsing template data:', error);
        }

        this.isProcessing = false;
      },
      error: (err) => {
        console.error('API Error fetching templates:', err);
        this.isProcessing = false;
      }
    });

    // Fetch organization report image details
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage(
    ).subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;

        // Fetch report logo data
        this.appService.getQmsReportLogoByModuleAndGroupId(
          "FRM",
          0
        ).subscribe({
          next: (data: any) => {
            this.dropDownDataForReportLogo = data;
            this.selectBoxForReportLogo();
            this.isProcessing = false;
          },
          error: (err) => {
            console.error('Error fetching report logo:', err);
            this.isProcessing = false;
          }
        });
      },
      error: (err) => {
        console.error('Error fetching organization image:', err);
        this.isProcessing = false;
      }
    });

    // Trigger footer change detection
    this.ngOnChangesReportFooter();
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  pdfDetailSearchText: string = '';
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const organizationReportImageDetail of this.organizationReportImageDetails) {

              console.log(
                "this.organizationReportImageDetails=",
                organizationReportImageDetail.reportImageId,
                this.imageIdList[i]
              );

              if (organizationReportImageDetail.reportImageId == this.imageIdList[i]) {

                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: organizationReportImageDetail.reportImageId,
                  displayExp: organizationReportImageDetail.reportImageName
                });

              }

            }
          }
        }
      } else {
        for (const organizationReportImageDetail of this.organizationReportImageDetails) {

          if (organizationReportImageDetail.reportImageId == this.dropDownDataForReportLogo.reportImageList) {

            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: organizationReportImageDetail.reportImageId,
              displayExp: organizationReportImageDetail.reportImageName
            });

          }

        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogoDropdownVal of this.reportLogoDropdown) {
          if (reportLogoDropdownVal.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = reportLogoDropdownVal.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
}
